MW.modules.storage = (function(){
  var get, set, remove, clear, has, supported, noop, storage, serialize, deserialize;
  supported = (function isLocalStorageSupported() {
    try {
      var testKey = 'test';
      storage = window.localStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }());

  deserialize = function(value) {
    if (typeof value != 'string') {
      return undefined;
    }
    try {
      return JSON.parse(value);
    } catch(e) {
      return value || undefined;
    }
  };

  serialize = function(value) {
    return JSON.stringify(value);
  };

  noop = function() {};

  if(!supported) {
    get = set = remove = clear = noop;
    has = function() { return false; };
  } else {
    get = function(key) {
      return deserialize(storage.getItem(key));
    };
    set = function(key, item) {
      try {
        storage.setItem(key, serialize(item));
      } catch (e) {
      }
    };
    remove = function(key) {
      storage.removeItem(key);
    };
    clear = function() {
      storage.clear();
    };
    has = function(key) {
      return storage.getItem(key) !== undefined;
    };
    if(!(get('lastPurge') > 1430758101108)) { // jshint ignore:line
      clear();
      set('lastPurge', Date.now());
    }
  }

  return {
    enabled: supported,
    get: get,
    set: set,
    remove: remove,
    clear: clear,
    has: has
  };
}());